module.exports = __webpack_public_path__ + "img/heaven_and_earth_box3.4d15eee0.png";